export default "__VITE_ASSET__CkNnh_q2__"